module.exports = __webpack_public_path__ + "img/illustration-editor-desktop.b4f9ff68.svg";